import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Radio as MuiRadio, styled } from "@mui/material";
const RadioIcon = styled("span")((param)=>{
    let { theme  } = param;
    return {
        borderRadius: "50%",
        width: 16,
        height: 16,
        border: "2px solid ".concat(theme.palette.grey[200]),
        backgroundColor: "transparent",
        transition: "background-color 0.2s, border-color 0.2s",
        ".Mui-focusVisible &": {
            outline: "2px auto ".concat(theme.palette.primary.main),
            outlineOffset: 2
        },
        "input:hover ~ &": {
            borderColor: theme.palette.grey[200]
        },
        "input:disabled ~ &": {
            backgroundColor: alpha(theme.palette.grey[300], 0.2),
            border: "none"
        }
    };
});
const RadioCheckedIcon = styled(RadioIcon)((param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before": {
            content: '""',
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: theme.palette.common.white
        },
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main
        },
        "input:disabled ~ &": {
            backgroundColor: alpha(theme.palette.grey[300], 0.2),
            border: "none",
            "&::before": {
                backgroundColor: alpha(theme.palette.grey[300], 0.2)
            }
        }
    };
});
const Radio = (props)=>{
    return /*#__PURE__*/ _jsx(MuiRadio, {
        color: "default",
        disableRipple: true,
        checkedIcon: /*#__PURE__*/ _jsx(RadioCheckedIcon, {}),
        icon: /*#__PURE__*/ _jsx(RadioIcon, {}),
        ...props
    });
};
export default Radio;
